import { create } from 'zustand';
import { EventScheduleValue } from '../types/types';

type Props = {
	setScheduleBeforeEdit: (data: EventScheduleValue | null) => void;
	scheduleBeforeEdit: EventScheduleValue | null;
	setSchedule: (data: EventScheduleValue | null) => void;
	schedule: EventScheduleValue | null;
	selectedDay: Date | null;
	setSelectedDay: (data: Date | null) => void;
};

export const useScheduleStore = create<Props>(set => ({
	schedule: null,
	scheduleBeforeEdit: null,
	setSchedule: (data: EventScheduleValue | null) => set({ schedule: data }),
	setScheduleBeforeEdit: (data: EventScheduleValue | null) =>
		set({ scheduleBeforeEdit: data }),
	selectedDay: null,
	setSelectedDay: (data: Date | null) => set({ selectedDay: data }),
}));
